import { Box, Grid2 as Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { CompleteLogin, SignupProcess } from './subComponents';
export const SignupSuccess = () => {
    return (React.createElement(Stack, { my: 8, mx: 3, alignItems: "center", justifyContent: "center" },
        React.createElement(Box, { width: "100%", maxWidth: "880px" },
            React.createElement(Typography, { mb: 1, color: "secondary", fontSize: "2rem", fontWeight: 600 }, "Congratulations!"),
            React.createElement(Typography, { color: "secondary.light", fontSize: "0.875rem", fontWeight: 500 }, "You have successfully kickstarted your grant journey!"),
            React.createElement(Box, { sx: {
                    p: 2,
                    mt: 2,
                    width: 'fit-content',
                    borderRadius: '16px',
                    backgroundColor: 'primary.light',
                } },
                React.createElement(Typography, { color: "primary.dark", fontSize: "0.9rem", fontWeight: 500 }, "Complete your login below to access GrantMatch and review your grant results.")),
            React.createElement(Grid, { container: true, spacing: 3, mt: 7 },
                React.createElement(Grid, { size: { xs: 12, sm: 7 } },
                    React.createElement(SignupProcess, null)),
                React.createElement(Grid, { size: { xs: 12, sm: 5 } },
                    React.createElement(CompleteLogin, null))))));
};
